import {IFlightInputValue} from '@mobi-components/global-flight-input';
import {IHotelInputValue} from '@mobi-components/global-hotel-input';
import {IMeetingInputValue} from '@mobi-components/global-meeting-input';
import {Activity, CandidatePoiItem, ISolution} from '@mobi-components/global-solution';

export interface ISubmitProblemRequest {
  flights: IFlightInputValue[];
  hotels: IHotelInputValue[];
  meetings: IMeetingInputValue[];
  places: IMeetingInputValue[];
  sessionId: string;
}
export interface ISubmitNewPlaceRequest {
  flights: IFlightInputValue[];
  hotels: IHotelInputValue[];
  meetings: IMeetingInputValue[];
  places: IMeetingInputValue[];
  sessionId: string;
  problemId: string;
}

interface SolutionDisplayOptions {
  display_whole_polyline: boolean;
  display_flights: boolean;
  display_accommodations: boolean;
}

export enum SubscriptionLevel {
  UNDER_SUBSCRIBED = 'UNDER_SUBSCRIBED',
}

export interface SolutionSpec {
  solutionId: string;
  candidates_evaluated: number;
  response_time: number;
  total_revenue: number;
  increased_revenue: number;
  endpoints_used: number;
  average_waiting: number | 'NaN';
  average_walking: number | 'Infinity';
  rental_car_revenue: number;
  rideshare_revenue: number;
  subscription_level: SubscriptionLevel;
  satisfied_filters: string[];
  contexts: CandidatePoiItem[];
}

export interface ExtendedSolutionResponse extends SolutionResponse {
  originalSolution: ISolution | null;
}
export interface SolutionResponse {
  solution: ISolution | null;
  spec: SolutionSpec | null;
  destination: SolutionSummary | null;
  session_id: string;
  display: SolutionDisplayOptions | null;
  explanations: string[] | null;
  highlights: {
    activities: Activity[];
    pois: CandidatePoiItem[];
    title: string;
  };
}

export interface SolutionSummary {
  time_zone: string;
  photo: string;
  name: string;
  lat: number;
  lng: number;
}
